/** Phones skip scroll-in entrances: content is visible immediately and nothing waits on scroll. */
export const SKIP_ENTRANCE = typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia('(max-width: 767px)').matches;
